import Alpine from "alpinejs";
import htmx from "htmx.org";
import toggle from "./toggle";
import navBar from "./components/nav-bar";
import flyoutMenu from "./components/flyout-menu";
import dropdown from "./components/dropdown";
import pagination from "./components/pagination";
import blog from "./components/blog";
import onOffButton from "./components/onOffButton";
import accordion from "./components/accordion";
import video from "./components/video";
//import ctaModal from "./components/cta-modal"; //using hubspot popup instead
//import ctaButton from "./components/cta-button";
import  "./script/general.ts"
import countrySelector from "./components/country-selector";

window.htmx = htmx;
window.Alpine = Alpine;
Alpine.data("toggle", toggle);
Alpine.data("navBar", navBar);
Alpine.data("flyoutMenu", flyoutMenu);
Alpine.data("dropdown", dropdown);
Alpine.data("pagination", pagination);
Alpine.data("blog", () => blog(null, '', false ));
Alpine.data("onoffbutton", onOffButton);
Alpine.data("accordion", accordion);
Alpine.data("video", video);
//Alpine.data("ctamodal", ctaModal);
//Alpine.data("ctabutton", ctaButton);
Alpine.data("countryselector", countrySelector);
Alpine.start();
